import { Layout, Palette, FileText, Plug, Settings, Headphones } from 'lucide-react';

export const DEFAULT_PLAN_FEATURES = [
  {
    icon: Layout,
    label: 'Sistema Completo',
    description: 'Acesso a todas as funcionalidades'
  },
  {
    icon: Palette,
    label: 'Interface Moderna',
    description: 'Design intuitivo e responsivo'
  },
  {
    icon: FileText,
    label: 'Relatórios Avançados',
    description: 'Análises e dashboards completos'
  },
  {
    icon: Plug,
    label: 'Integrações',
    description: 'APIs e conectores disponíveis'
  },
  {
    icon: Settings,
    label: 'Customizações',
    description: 'Personalize conforme sua necessidade'
  },
  {
    icon: Headphones,
    label: 'Suporte Técnico',
    description: 'Atendimento especializado'
  }
];
